<template>
  <div class="radio-group" :class="size">
    <div v-for="(option,i) in options"
         class="radio-group__item"
         :class="{'selected': selected === option.val,'disabled': option.disabled  }"
         :key="i"
         @click="click(option)">
      {{ option.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioGroup",
  props: {
    size: {
      type: String
    },
    options: {
      required: true,
      type: Array
    },
    selected: {
      type: Number,
      required: true,
    }
  },
  methods: {
    click(opt) {
      if (!opt.disabled)
        this.$emit('pick', opt.val)
    }
  }
}
</script>

<style lang="scss">
.radio-group {
  &__item {
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 15px;
    color: #757D85;
    position: relative;
    height: 24px;
    padding-left: 46px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    cursor: pointer;

    &:before {
      @apply left-0 top-0 absolute h-8 w-8 bg-block rounded-full border border-border ;
      content: '';
    }

    &:after {
      content: '';
      position: absolute;
      left: 5px;
      top: 5px;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      opacity: 0;
      background: #486680;
    }

    &.selected {
      &:before {
        border-color: #486680;
      }

      &:after {
        opacity: 1;
      }
    }

    &.disabled {
      cursor: not-allowed;

      &:before {
        background: darken(white, 5);
      }

      &:before, &:after {
        filter: grayscale(100%);
      }
    }
  }

  &.sm {
    margin-bottom: 27px;
    margin-top: 0;

    .radio-group__item {
      font-family: 'Open Sans', sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 11px;
      line-height: 15px;
      color: #757D85;
      padding-left: 30px;
      margin-bottom: 3px;

      &:before {
        top: 2px;
        width: 18px;
        height: 18px;
      }

      &:after {
        left: 3.5px;
        top: 5.5px;
        width: 10.5px;
        height: 10.5px;
      }
    }
  }
}
</style>
